import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { CheckCircle, Clock } from 'lucide-react';
import { format } from 'date-fns';

export const ConsoleAdjournmentTab = ({ adjournment, setAdjournment, saveAdjournment, users }) => (
  <div className="space-y-5">
    {/* 1) Announcements or Reminders */}
    <div>
      <Label className="text-sm font-semibold text-[#1A1D21]">1. Announcements or Reminders</Label>
      <Textarea value={adjournment.announcements || ''} onChange={e => setAdjournment({ ...adjournment, announcements: e.target.value })}
        onBlur={() => saveAdjournment({ announcements: adjournment.announcements })}
        placeholder="Record any announcements or reminders for the Board/Committee..." className="mt-1 border-[#E2E6EA] min-h-[80px]" data-testid="adjournment-announcements" />
    </div>

    {/* 2) Other Updates or Roundtable */}
    <div>
      <Label className="text-sm font-semibold text-[#1A1D21]">2. Other Updates or Roundtable Discussions</Label>
      <p className="text-xs text-[#5A6570] mt-0.5 mb-1">(Optional) Record any roundtable discussions or updates.</p>
      <Textarea value={adjournment.roundtable || ''} onChange={e => setAdjournment({ ...adjournment, roundtable: e.target.value })}
        onBlur={() => saveAdjournment({ roundtable: adjournment.roundtable })}
        placeholder="Roundtable updates or discussions..." className="mt-1 border-[#E2E6EA] min-h-[80px]" data-testid="adjournment-roundtable" />
    </div>

    {/* 3) Adjournment */}
    <div>
      <Label className="text-sm font-semibold text-[#1A1D21]">3. Adjournment</Label>
      <div className="mt-2 space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs">Motion to Adjourn By</Label>
            <Select value={adjournment.motion_by || ''} onValueChange={v => saveAdjournment({ motion_by: v })}>
              <SelectTrigger className="border-[#E2E6EA] h-8 text-sm" data-testid="adjournment-motion-by"><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>{users.map(u => <SelectItem key={u.id} value={u.id}>{u.full_name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label className="text-xs">Seconded By</Label>
            <Select value={adjournment.seconded_by || ''} onValueChange={v => saveAdjournment({ seconded_by: v })}>
              <SelectTrigger className="border-[#E2E6EA] h-8 text-sm" data-testid="adjournment-seconded-by"><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>{users.map(u => <SelectItem key={u.id} value={u.id}>{u.full_name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Checkbox checked={adjournment.approved || false} onCheckedChange={checked => saveAdjournment({ approved: checked })}
            className="border-[#00A3A3] data-[state=checked]:bg-[#00A3A3]" data-testid="adjournment-approved" />
          <Label className="text-sm text-[#1A1D21]">Motion to Adjourn Approved</Label>
        </div>

        {adjournment.approved && (
          <div className="flex items-center gap-3">
            <Checkbox checked={adjournment.declared || false}
              onCheckedChange={checked => {
                const updates = { declared: checked };
                if (checked && !adjournment.declaration_time) updates.declaration_time = new Date().toISOString();
                if (!checked) updates.declaration_time = null;
                saveAdjournment(updates);
              }}
              className="border-[#F58A26] data-[state=checked]:bg-[#F58A26]" data-testid="adjournment-declared" />
            <Label className="text-sm text-[#1A1D21]">Adjournment Declared</Label>
          </div>
        )}

        <div className="mt-2 p-3 rounded-lg border border-[#E2E6EA] bg-[#F8F9FA]" data-testid="declaration-time">
          {adjournment.declaration_time ? (
            <div className="flex items-center gap-2"><CheckCircle className="h-4 w-4 text-green-600" /><span className="text-sm font-medium text-green-800">Adjournment declared at {format(new Date(adjournment.declaration_time), 'h:mm a')}</span></div>
          ) : (
            <div className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#A8B1B9]" /><span className="text-sm text-[#5A6570]">Time is recorded when "Adjournment Declared" is checked</span></div>
          )}
        </div>
      </div>
    </div>
  </div>
);
